export const FORMAT_24 = {
  name: '24 hour',
  value: '24',
};

export const FORMAT_12 = {
  name: '12 hour',
  value: '12',
};

const Basic = [FORMAT_24, FORMAT_12];

const BasicByValue = Basic.reduce((hash, format) => {
  hash[format.value] = format;
  return hash;
}, {});

export default { Basic, BasicByValue };
